<template>
  <header class="game-header">
  </header>
</template>

<script>
export default {
  name: 'GameHeader'
};
</script>

<style scoped>
.game-header {
  background-color: var(--dark-slate-gray);
  padding: 10px 0;
  z-index: 50;
  border-bottom: 2px solid var(--game-accent, var(--cyber-yellow));
}
</style>